import { useFormInput } from '@/hooks';
import { Error, Group, Input as BaseInput, Label } from './Partials';
import { FormInputProps } from '@/types';

type InputProps = FormInputProps<HTMLInputElement>;

export const Input = ({ id, name, label, required = false, disabled = false, groupClassName, ...rest }: InputProps) => {
    const { value, setValue, error } = useFormInput<string>(name);

    return (
        <Group className={groupClassName}>
            <Label
                htmlFor={id ?? name}
                required={required}
                disabled={disabled}
                invalid={error !== undefined}>
                {label}
            </Label>

            <BaseInput
                {...rest}
                id={id ?? name}
                name={name}
                value={value ?? ''}
                onChange={(e) => setValue(e.target.value)}
                invalid={error !== undefined} />

            <Error error={error} />
        </Group>
    );
};
